export const groupByRows = (rows) => {
  const arr = [];
  let sourceRows = JSON.parse(JSON.stringify(rows));
  let temp0 = sourceRows.filter(x => x.pallet_id > -1);
  let temp1 = sourceRows.filter(x => x.pallet_id === -1);

  temp0 = temp0.sort(function (a, b) { return a.goods_spec_name && b.goods_spec_name ? a.goods_spec_name.localeCompare(b.goods_spec_name) : false });
  temp1 = temp1.sort(function (a, b) { return a.goods_spec_name && b.goods_spec_name ? a.goods_spec_name.localeCompare(b.goods_spec_name) : false });
  sourceRows = temp0.concat(temp1);
  sourceRows.filter(row => row.goods_spec_id).forEach(x => {
    x.palletCount = undefined;
    if (!arr.find(y => y.pallet_id === x.pallet_id)) {
      const subRows = sourceRows.filter(z => z.pallet_id === x.pallet_id);
      arr.push(
        {
          pallet_id: x.pallet_id,
          palletCount: x.pallet_id > -1 ? 1 : 0,
          goodsSpecCount: subRows.length,
          goodsSpecId: subRows.length === 1 ? subRows[0].goods_spec_id : undefined,
          subRows: subRows
        }
      );
    }
  });
  return arr;
}
export const calcMerge = (tempRows) => {
  const merge = [];
  tempRows.forEach((x, i) => {
    if (x.merge > 1) {
      merge.push({ start: i, end: i + x.merge - 1 });
    }
  });
  return merge;
}
export const calcCartonRatio = (tempRows) => {
  tempRows.filter(f => f.palletCount > 0 || f.palletCount === -1).forEach(x => {
    const temp = tempRows.filter(y => y.pallet_id === x.pallet_id);
    let weights = 0;
    let cartonCountPerPallet = 0;
    temp.forEach(s => {
      weights += (/*s.count **/ s.weight);
      s.totalWeights = undefined;
      cartonCountPerPallet += s.carton_count;
    });
    temp[0].totalWeights = weights * (x.palletCount > 1 ? x.palletCount : 1);
    if (temp.length > 1) {
      temp[0].merge = temp.length;
      temp[0].carton_count_per_pallet = cartonCountPerPallet;
    }
    if (x.palletCount === -1) {
      x.palletCount = '散';
    }
  });

  return tempRows;
}

export const combineRows = (rows) => {
  const total = {
    total_cartons: 0,
    total_pallets: 0
  };
  const arr = [];
  const temp = groupByRows(rows);
  temp.forEach(x => {
    let subCartonCount = 0;
    x.subRows.forEach(s => {
      s.weights = s.weight;// * s.count;
      s.amount = s.price * s.count;
      subCartonCount += s.carton_count;
    });
    if (x.pallet_id === -1) {
      x.subRows[0].palletCount = -1;
      total.total_cartons = subCartonCount;
    } else {
      total.total_pallets += 1;
      x.subRows[0].palletCount = 1;
    }

    if (x.goodsSpecCount !== 1 || x.pallet_id === -1) {
      arr.push(x);
    } else {
      const find = arr.find(y => y.goodsSpecId === x.goodsSpecId);
      if (find) {
        if (find.subRows[0].carton_count / find.palletCount !== x.subRows[0].carton_count) {
          arr.push(x);
        } else {
          find.palletCount += 1;
          find.subRows[0].palletCount = find.palletCount;
          find.subRows[0].carton_count += x.subRows[0].carton_count;
          find.subRows[0].count += x.subRows[0].count;
        }
      } else {
        arr.push(x);
      }
    }
  });
  return { total, arr };
}

const calcTableRows = (rows) => {
  let arr1 = [];
  const { total, arr } = combineRows(rows);
  arr.forEach(x => {
    arr1 = arr1.concat(x.subRows);
  });
  return { total, arr: arr1 };
}

const addBlankRow = (rows) => {
  const arr = [];
  rows.forEach((x,i)=> {
    arr.push(x);
    if (rows[i+1] && rows[i+1].palletCount) {
      arr.push({});
    }
  })
  return arr;
}
export const parsePackageList = (pkgs, packageNo, total = undefined, rows = undefined) => {
  let temp = undefined;
  let tempTotal = undefined;
  let obj = undefined;
  if (rows) {
    temp = rows;
  } else {
    obj = calcTableRows(pkgs);
    temp = obj.arr;
  }
  if (total) {
    tempTotal = total;
  } else {
    tempTotal = obj.total;
  }
  temp = calcCartonRatio(temp);
  temp = addBlankRow(temp);
  let merge = calcMerge(temp);

  return {
    info: {
      no: packageNo.no,
      goods_code: packageNo.goods_code || '',
      buyer_name: packageNo.buyer_name,
      po_code: packageNo.po_code,
      sdate: packageNo.sdate,
      supplier_name: packageNo.supplier_name,
      delivery_date: packageNo.delivery_date,
      total_pallets: tempTotal.total_pallets,
      total_cartons: tempTotal.total_cartons,
      remark: packageNo.remark,
      pallet_flag: packageNo.pallet_flag
    },
    rows: temp,
    merge: merge
  }
}